export function parseReference(reference) {
    if (!reference) {
        return null;
    }

    const values = reference.split("|");

    if (values.length !== 4) {
        return null;
    }

    const serverUrl = values[0].trim();
    const service = values[1].trim();
    const className = values[2].split(".").pop();
    const resource = className.replace(/DTO$/, "").toLowerCase() + "s";
    const id = values[3].trim();
    const baseURL = [serverUrl, service, "api"].filter(Boolean).join("/");

    return {
        resource,
        id,
        baseURL
    };
}